import { render, staticRenderFns } from "./AppLayoutComissao.vue?vue&type=template&id=0b0534e2"
import script from "./AppLayoutComissao.vue?vue&type=script&lang=js"
export * from "./AppLayoutComissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports